import { render } from "./AboutManagement.vue?vue&type=template&id=7f270b12&scoped=true"
import script from "./AboutManagement.vue?vue&type=script&lang=js"
export * from "./AboutManagement.vue?vue&type=script&lang=js"

import "./AboutManagement.vue?vue&type=style&index=0&id=7f270b12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f270b12"]])

export default __exports__